import React from 'react'
// import {Link} from "react-router-dom"
import { Link, FooterWrapper, Copywrite, Connect } from "./FooterStyle"
import {  FaTwitter, FaLinkedinIn, FaGithub } from "react-icons/fa";

// FaFacebook,
function Footer() {
    return (
        <FooterWrapper>
            <Copywrite>&copy; Ubani U. Friday</Copywrite>
            <Connect>
                {/* <Link
                    href="https://facebook.com/callmefarad"
                    target="_blank"
                    rel="noopener"
                    primary
                >
                    <FaFacebook />
                </Link > */}
                <Link 
                    href="http://twitter.com/callmefarad"
                    target="_blank"
                    rel="noopener"
                    primary
                >
                    <FaTwitter />
                </Link>
                <Link 
                    href="https://www.linkedin.com/in/callmefarad/"
                    target="_blank"
                    rel="noopener"
                    primary
                >
                    <FaLinkedinIn />
                </Link>
                <Link 
                    href="https://github.com/callmefarad"
                    target="_blank"
                    rel="noopener"
                    primary
                >
                    <FaGithub />
                </Link>
            </Connect>
        </FooterWrapper>
    )
}

export default Footer
